import Breadcrumb from "../components/BreadCurmb";
import HeaderOne from "../header/HeaderOne";
import FooterOne from "../footer/FooterOne";
import PortfolioContent from "../components/PortfolioContent";
import RelatedPortfolio from "../components/RelatedPortfolio";

export default function CaseDetails(){

	return(
		<>		
			<HeaderOne/>
			<Breadcrumb title={"Portfolio Details"} pagetitle={"Case Details"} subtitle={"Responsive & functional IT design"}/>		
			<PortfolioContent />
			<RelatedPortfolio/>
			<FooterOne/>	
		</>
	)
}